import React from 'react';
import { Control, UseFormSetValue, UseFormWatch, FieldErrors, useFieldArray } from 'react-hook-form';
import { FiliationAndMaritalStatusFieldset, ChildrenFieldset, FamilyDocumentsFieldset } from '@/features/Collaborators/Edit/Form/Fieldsets';
import { CollaboratorFormData } from '@/features/Collaborators/Edit/Types';
import { CollaboratorFormContext } from "@/features/Collaborators/Edit/Contexts/CollaboratorFormContext";

interface FamilyTabProps {
    context: CollaboratorFormContext;
    collaboratorId: string;
    control: Control<CollaboratorFormData>;
    setValue: UseFormSetValue<CollaboratorFormData>;
    watch: UseFormWatch<CollaboratorFormData>;
    errors: FieldErrors<CollaboratorFormData>;
    isSubmitting?: boolean;
}

const FamilyTab: React.FC<FamilyTabProps> = ({
    context,
    collaboratorId,
    control,
    setValue,
    watch,
    errors,
    isSubmitting = false
}) => {
    const { fields, append, remove } = useFieldArray({
        control,
        name: 'children'
    });

    return (
        <div className="space-y-6">
            <FiliationAndMaritalStatusFieldset
                context={context}
                control={control}
                errors={errors}
                watch={watch}
            />

            <ChildrenFieldset
                context={context}
                control={control}
                errors={errors}
                fields={fields}
                append={append}
                remove={remove}
            />

            <FamilyDocumentsFieldset
                context={context}
                collaboratorId={collaboratorId}
                control={control}
                setValue={setValue}
                watch={watch}
                errors={errors}
                isSubmitting={isSubmitting}
            />
        </div>
    );
};

export default FamilyTab;
